import styled from 'styled-components';

export const StyledTableContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-typography {
        margin: auto 0;
    }
`;

export const StyledExtraConfigurationTableHeader = styled(StyledTableContainer)`
    margin-bottom: 1rem;
`;
